import { jsxs as l, jsx as i } from "react/jsx-runtime";
import { useState as x } from "react";
import t from "styled-components";
import f from "../../Icons/Smile.js";
import o from "../../../utils/colors.js";
import { device as r } from "../../../utils/device.js";
const m = t.a`
  text-decoration: none;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  cursor: pointer;

  @media ${r.isTablet} {
    justify-content: flex-start;
  }
`, h = t.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: 45px;
  height: 45px;
  margin-right: 25px;

  @media ${r.isTablet} {
    padding-bottom: 2px;
  }
`, g = t.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 9px;
  padding-top: 10px;
  border: 2px solid white;
  border-radius: 100px;
  transition: border-color 0.1s ease-in-out;
  padding-left: 10px;

  > svg:hover {
    color: ${o.orange};
  }
`, u = t.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  margin-top: 0px;

  @media ${r.isTablet} {
    margin-bottom: 5px;
  }
`, s = t.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`, b = t(s)`
  font-weight: 500;
  line-height: 1.125rem;
  color: ${o.white};

  @media ${r.isTablet} {
    font-weight: 600;
  }
`, y = t(s)`
  padding-top: 5px;
  line-height: 1.2;
  color: ${o.white};

  @media ${r.isTablet} {
    padding-top: 3px;
  }
`, E = ({ title: a, subtitle: c, link: d, onClick: p = () => {
} }) => {
  const [e, n] = x(() => o.white);
  return /* @__PURE__ */ l(
    m,
    {
      href: d,
      onClick: p,
      onMouseEnter: () => n(o.orange),
      onMouseLeave: () => n(o.white),
      children: [
        /* @__PURE__ */ i(h, { children: /* @__PURE__ */ i(g, { style: { color: e, borderColor: e }, children: /* @__PURE__ */ i(f, { fill: e }) }) }),
        /* @__PURE__ */ l(u, { children: [
          /* @__PURE__ */ i(b, { style: { color: e, borderColor: e }, children: a }),
          /* @__PURE__ */ i(y, { style: { color: e, borderColor: e }, children: c })
        ] })
      ]
    }
  );
};
export {
  E as default
};
